import { useQuery } from '@tanstack/react-query';

import { AxiosClient } from '@hcs/http-clients';
import { IS_LOCAL } from '@hcs/webapps';

const QUERY_KEY_LATEST_RELEASE_VERSION = 'QUERY_KEY_LATEST_RELEASE_VERSION';
export const useLatestReleaseVersion = () => {
  return useQuery({
    queryKey: [QUERY_KEY_LATEST_RELEASE_VERSION],

    queryFn: async () => {
      const response = await AxiosClient.get<{ version: string }>(
        `/version.json`,
      );
      return response.data.version;
    },
    refetchOnWindowFocus: true,
    enabled: !IS_LOCAL, // Disable in local environment
  });
};
